import type { Screen } from '@otter-ai/telemetry';
import { ErrorBoundary } from 'react-error-boundary';
import { createErrorHandler } from '@/shared/components/SectionalErrorBoundary';
import { openDialog } from '@/shared/modals/openDialog';

export function openImportPaywallDialog({ screen }: { screen: Screen }) {
  return openDialog(async ({ done }) => {
    const { ImportPaywallDialog } = await import('./ImportPaywallDialog');
    return (
      <ErrorBoundary
        fallback={null}
        onError={(error) => {
          createErrorHandler({
            loggerName: 'import',
            eventName: 'ImportPaywallDialogError',
            section: 'ImportPaywallDialog',
          })(error);
          done();
        }}
      >
        <ImportPaywallDialog done={done} screen={screen} />
      </ErrorBoundary>
    );
  });
}
